import React, {useState} from "react";
import InputsRecebivelRural from "./InputsRecebivelRural";
import PopupAdd from "../../../component/PopupAdd/PopupAdd";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";

export default function PopupAddRecebivel({baseUrl, setLoadData}) {

    const [data, setData] = useState({})
    const [files, setFiles] = useState([])

    const [error, setError] = useState("")
    const [errorMessage, setErrorMessage] = useState("")
    const [errorColumn, setErrorColumn] = useState("")
    const [blockSubmit, setBlockSubmit] = useState("")
    const [clear, setClear] = useState(true)

    const headers = {
        'Content-Type': 'multipart/form-data'
    }

    const inputs = <InputsRecebivelRural
        setData={setData} files={files} setFiles={setFiles}
        error={error} setBlockSubmit={setBlockSubmit}
        clear={clear} setClear={setClear}
    />

    const icon = <PointOfSaleIcon fontSize="large" id="icon-svg"/>

    const clearForm = () => {
        setError('')
        setErrorMessage(false)
        setErrorColumn(false)

        setClear(true)
    }

    const returnData = () => {
        const formData = new FormData();
        formData.append('data', JSON.stringify(data));
        for (let file of files) {
            formData.append('files', file);
        }

        return formData
    }

    const validateData = () => {
        setError('')
        if (data.valor > 0)
            return true
        else {
            setError("O valor deve ser maior que 0!")
            return false
        }
    }

    return <PopupAdd
        baseUrl={baseUrl} setLoadData={setLoadData}
        validateData={validateData}
        inputs={inputs} title={'Adicionar Recebível'} icon={icon}
        clearForm={clearForm} returnData={returnData}
        setErrorMessage={setErrorMessage} setErrorColumn={setErrorColumn}
        blockSubmit={blockSubmit} headers={headers}
    />
}